import { Box, Button, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CompositeCbctDialog from '~/containers/workflows/composite-cbct/CompositeCbctDialog';
import usePrimaryImage from '~/hooks/image/usePrimaryImage';
import { useCompositeCbctEligibility } from '~/hooks/image/useCompositeCbctEligibility';
import { WorkflowTypes } from '~/state/atoms/viewerAtoms';
import AiAssistantButton from '../../AiAssistantButton';
import DatasetPicker from '../ContouringStep/DatasetPicker/DatasetPicker';
import StepHeader from '../StepHeader';
import IsroResultPanel from './IsroResultPanel';

export default function SyntheticImagingContent() {
    const { availableImages } = usePrimaryImage(true);
    const [isCompositeCbctOpen, setIsCompositeCbctOpen] = useState(false);
    const { canBuild, blockedMessageId } = useCompositeCbctEligibility();
    const isCompositeCbctDisabled = !canBuild;

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <Box flex={1} overflow="auto" minHeight={0}>
                <StepHeader titleId="workflow.syntheticImaging" />

                <Box
                    px={2}
                    my={1}
                    mb={1.5}
                    display="flex"
                    flexDirection="column"
                    gap={1}
                >
                    <AiAssistantButton page={WorkflowTypes.IMAGE} />
                    <Tooltip
                        title={
                            blockedMessageId ? (
                                <FormattedMessage id={blockedMessageId} />
                            ) : (
                                ''
                            )
                        }
                        placement="right"
                    >
                        <Box component="span">
                            <Button
                                fullWidth
                                variant="outlined"
                                disabled={isCompositeCbctDisabled}
                                onClick={() => setIsCompositeCbctOpen(true)}
                                data-testid="composite-cbct-button"
                                sx={{
                                    textTransform: 'capitalize',
                                    fontSize: 12,
                                }}
                            >
                                <FormattedMessage id="compositeCbct" />
                            </Button>
                        </Box>
                    </Tooltip>
                </Box>
                <Box px={2}>
                    <DatasetPicker />
                </Box>
                <CompositeCbctDialog
                    open={isCompositeCbctOpen}
                    onClose={() => setIsCompositeCbctOpen(false)}
                />
                <IsroResultPanel />

                {availableImages.length === 0 && (
                    <Box display="flex" px={2} pt={1}>
                        <Typography color="text.secondary" fontSize={12}>
                            <FormattedMessage id="noImagesAvailable" />
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
}
